import React, { useEffect } from "react";
import AOS from "aos";

import {
  Container,
  Wrapper,
} from "web/pages/public/landing-page/NewsRoom/SocialMediaCatchUp/SocialMediaCatchUpStyled";
import SocialMediaNews from "../SocialMediaNews";

const SocialMediaCatchUp = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      offset: 50,
    });
  }, []);
  return (
    <Container data-aos="fade-up" data-aos-delay="400">
      <Wrapper>
        <h4 className="social-media-heading">Social media is talking, too.</h4>
        <h5 className="social-media-sub-heading">
          Here’s a small sample of the buzz on social media.
        </h5>
        <SocialMediaNews />
      </Wrapper>
    </Container>
  );
};

export default SocialMediaCatchUp;
